(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roaster-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-roaster-description]').forEach((wrapper) => {
    const text = wrapper.querySelector('.roaster-hero__description-text');
    const button = wrapper.querySelector('.roaster-hero__more');
    if (!text || !button) return;

    const update = () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) return;
      button.hidden = text.scrollHeight <= text.clientHeight + 2;
    };

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      wrapper.classList.toggle('is-expanded', !expanded);
      button.textContent = expanded ? button.dataset.more : button.dataset.less;
    });

    update();
    window.addEventListener('resize', update);
  });

  } catch(e) { console.error(e); }
})();
})();
